import React from "react";
import { twMerge } from "tailwind-merge";

export type TitleVariant =
  | "primary"
  | "secondary"
  | "stats"
  | "small"
  | "tertiary"
  | "h2"
  | "h3"
  | "h4"
  | "paragraph";

export interface TitleProps extends React.HTMLAttributes<HTMLDivElement> {
  titleText: string;
  variant: TitleVariant;
}
const Title: React.FunctionComponent<TitleProps> = ({
  titleText,
  className,
  variant = "primary",
  ...rest
}) => {
  const variantClassName = {
    primary:
      "text-center xl:text-left text-4xl md:text-[56px] xl:text-6xl 2xl:text-7xl leading-[44px] md:leading-[62px] xl:leading-[69px] 2xl:leading-[81px] text-white font-medium max-w-[720px] xl:max-w-[649px] text-dark-purple-50",
    secondary:
      "text-center text-dark-purple-50 font-semibold text-sm md:text-[36px] md:leading-[48px]",
    tertiary:
      "text-2xl text-dark-purple-50 font-semibold leading-[32px] text-center",
    stats:
      "text-center text-4xl sm:text-3xl md:text-4xl xl:text-[54px] font-black md:leading-[48px]",
    small: "text-center text-base font-semibold text-dark-purple-50",
    h2: "text-dark-purple-50 text-2xl font-semibold leading-[32px] xl:text-4xl xl:leading-[48px] mb-3 xl:mb-4",
    h3: "text-lg text-dark-purple-50 font-medium leading-[24px] xl:text-2xl mb-2",
    h4: "text-lg text-dark-purple-50 font-medium leading-[24px] xl:text-2xl mb-2",
    paragraph:
      "text-dark-purple-50 text-sm font-normal leading-[24px] xl:text-base xl:leading-[26px]",
    homeHeader:
      "text-2xl xl:text-[40px] text-dark-purple-50 max-w-[347px] xl:leading-[49.50px] leading-6 font-normal",
  };
  if (!titleText) return <></>;
  return (
    <div className={twMerge(variantClassName[variant], className)} {...rest}>
      {titleText}
    </div>
  );
};
export default Title;
